import config from '@/config';
import { requests } from '.';
const CONTACT_SERVICE_URl = config === null || config === void 0 ? void 0 : config.CONTACT_SERVICE_URl;
export const ContactService = {
    getContactDetails: (id) => requests(CONTACT_SERVICE_URl).get(`/${id}`),
    create: (body) => requests(CONTACT_SERVICE_URl).post('/?version=14-05-22', body),
    searchByName: (locationId, searchQuery) => requests(CONTACT_SERVICE_URl).get(`/`, {
        params: {
            locationId: locationId,
            query: searchQuery,
            limit: 50,
        },
        headers: {
            channel: 'APP',
        },
    }),
};
